import { render, staticRenderFns } from "./mechanismdetail.vue?vue&type=template&id=42a04b0c&"
import script from "./mechanismdetail.vue?vue&type=script&lang=js&"
export * from "./mechanismdetail.vue?vue&type=script&lang=js&"
import style0 from "./mechanismdetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports